export default "__VITE_ASSET__DJZQogS1__"